export const GRID_VIEW = 'GRID';

export const LIST_VIEW = 'LIST';

export const DEFAULT_VIEW = GRID_VIEW;

export const ProductsViewModeTypes = {
  GRID: GRID_VIEW,
  LIST: LIST_VIEW,
};